<script>
    import DatePicker from 'vue2-datepicker'

    const isObject = function (obj) {
        return obj !== null && typeof obj === 'object'
    }

    export default {
        extends: DatePicker,
        name: "vue2-datepicker",
        data() {
            return {
                'zh-HK': {
                    'days': ['日', '一', '二', '三', '四', '五', '六'],
                    'months': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                    'pickers': ['未來七天', '未來三十天', '前七天', '前三十天'],
                    'placeholder': {
                        'date': '選擇日子',
                        'dateRange': '選擇日期範圍'
                    }
                },
                'en': {
                    'days': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    'months': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    'pickers': ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    'placeholder': {
                        'date': 'Select Date',
                        'dateRange': 'Select Date Range'
                    }
                },
            }
        },
        props: {
            lang: {
                type: [String, Object],
                default: () => window.locale,
            },
        },
        computed: {
            translation() {
                if (isObject(this.lang)) {
                    return {...this.en, ...this.lang}
                }
                return this[this.lang] || this.en
            },
        },
    }
</script>

<style scoped>
    .hasError {
        border-color: #dc3545;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DatePicker/DatePickerExtended.vue